export const getTemplateLessonId = (lesson) =>
  lesson?.template_lesson_id ?? lesson?._id ?? lesson?.lesson_id ?? null;

export const getTemplateItemId = (item) => item?.template_item_id ?? item?._id ?? null;

export const WORKBOOK_V2_ANSWER_SAVE_DEBOUNCE_MS = 1000;

export const getWorkbookByCreditApiPath = (creditId) => `/user/workbook/v2/credits/${creditId}`;

export const getWorkbookClientPath = (workbook, templateLessonId = null) => {
  if (!workbook?.credit_id) {
    return '/library';
  }

  if (workbook.workbook_version === 2) {
    if (templateLessonId) {
      return `/library/v2/${workbook.credit_id}?lesson=${templateLessonId}`;
    }

    return `/library/v2/${workbook.credit_id}`;
  }

  return `/library/${workbook.credit_id}`;
};

export const getLessonByTemplateApiPath = (creditId, templateLessonId) =>
  `/user/workbook/v2/credits/${creditId}/lessons/${templateLessonId}`;

export const getLessonByPageApiPath = (creditId, pageNumber) =>
  `/user/workbook/v2/credits/${creditId}/lessons/by-page/${pageNumber}`;

export const getItemByTemplateApiPath = (creditId, templateItemId) =>
  `/user/workbook/v2/credits/${creditId}/items/${templateItemId}`;

export const buildWorkbookItemSavePayload = ({ answer, answers, highlights, lessonId }) => {
  const payload = {};

  if (answer !== undefined) {
    payload.answer = answer;
  }

  if (answers !== undefined) {
    payload.answers = answers;
  }

  if (highlights !== undefined) {
    payload.highlights = highlights;
  }

  if (lessonId) {
    payload.lesson_id = lessonId;
  }

  return payload;
};
